import { message } from "antd";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { queryWxCode, getLoginQrCode, queryQrCodeStatus, doRelativeLogin } from "@api/login";
import { queryUserByToken } from "../../../api/user";
import { setCookie, judge } from "@util/utils";
import { ym_url } from "@util/enum";
import brightlogo from "@assets/images/bright-logo.png";
// import pzLogo from "@assets/images/pz-logo.png";
import wxLogo from "@assets/images/wx-logo.png";
import "./login_interceptor.less";
import loginContext from "@components/login_context";
import { queryWxCallbackUrl } from "../../../api/login";
import {
  getLoginModalWechatReturnContext,
  saveLoginModalWechatReturnContext,
  saveLoginModalWechatReturnUrl,
} from "@components/login_modal/wechatReturn";

export default function OtherLogin({
  setVisible,
  setOtherLoginVisible,
  loginName,
  setLoginName,
  setPwdLogin,
  serDirect,
  direct,
  isShop,
  shopPlatFun,
}) {
  const { t } = useTranslation();
  const [interval, set_interval] = useState(null);
  const isWx = judge();

  const {
    loginSucCallback,
    platform,
    getUrlByHadParam,
    isPhone,
    isPhoneWx,
    privateMemberOpen,
    privateMemberTeamId,
    privateMemberInviterId,
    privateMemberSource,
  } = useContext(loginContext);
  const privateMemberWxLoginParams = useMemo(() => {
    if (!isPhoneWx || !privateMemberOpen || !privateMemberTeamId) {
      return {};
    }

    const inviterId = privateMemberInviterId ? Number(privateMemberInviterId) : null;
    const hasInviterId = inviterId !== null && !Number.isNaN(inviterId) && inviterId > 0;
    return {
      teamId: privateMemberTeamId,
      ...(hasInviterId ? { inviterId } : {}),
      ...(privateMemberSource ? { source: privateMemberSource } : {}),
    };
  }, [isPhoneWx, privateMemberInviterId, privateMemberOpen, privateMemberSource, privateMemberTeamId]);
  const appendPrivateMemberWxLoginParams = (params = {}) => ({
    ...params,
    ...privateMemberWxLoginParams,
  });
  const hasBoundLoginContact = (user) =>
    Boolean(String(user?.phone || "").trim() || String(user?.email || "").trim());
  const buildWxWebLoginUrl = (origin, key) => {
    const params = new URLSearchParams({
      key: key || "",
      platform,
    });
    Object.entries(privateMemberWxLoginParams).forEach(([name, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.set(name, value);
      }
    });
    return `${origin}/api/wx/webLogin?${params.toString()}`;
  };

  useEffect(() => {
    setCookie('platform', platform, 7)
  }, [platform])
  const queryCodeFn = () => {
    const { key, val, url } = getUrlByHadParam(1, true);
    const ym = window.location.origin;
    const privateMemberReturnUrl =
      url || `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const shouldUseWxSucCallback = Boolean(privateMemberWxLoginParams.teamId);
    if (shouldUseWxSucCallback) {
      saveLoginModalWechatReturnContext({
        returnUrl: privateMemberReturnUrl,
        shouldJoin: true,
        ...privateMemberWxLoginParams,
      });
    }
    let callback = "";
    if (url) {
      callback = ym + url;
      localStorage.setItem(key, val);
      if (key === 'clientId') localStorage.setItem('entrust', val);
    }
    const callbackTarget = shouldUseWxSucCallback
      ? `${window.location.origin}/wx_suc.html?fromLoginModal=1`
      : callback;
    if (callbackTarget) {
      queryWxCallbackUrl({ redirectUrl: callbackTarget }).then((res) => {
        if (res.success) {
          queryWxCode(appendPrivateMemberWxLoginParams({ platform, callback: res.result })).then((res) => {
            if (res.success) {
              setLoginName("微信登录");
              setVisible(false);
              setOtherLoginVisible(true);
              // 关闭快捷登录
              serDirect(res.result?.split("redirect:")[1]);
              // window.location.href = "/";
            } else {
              message.error(t(res.errorInfo));
            }
          });
        }

      })
    } else {
      queryWxCode(appendPrivateMemberWxLoginParams({ platform, callback: callbackTarget })).then((res) => {
        if (res.success) {
          setLoginName("微信登录");
          setVisible(false);
          setOtherLoginVisible(true);
          serDirect(res.result?.split("redirect:")[1]);
          // window.location.href = "/";
        } else {
          message.error(t(res.errorInfo));
        }
      });
    }




  };
  const queryQrCodeFn = () => {
    getLoginQrCode({
      width: 300,
      height: 300,
    }).then((res) => {
      if (res.success) {
        setLoginName("盘子登录");
        setVisible(false);
        setOtherLoginVisible(true);
        serDirect(res.result?.qrCodeUrl);
        queryQrCodeStatusFn(res.result?.qrCodeKey);
      } else {
        message.error(t(res.errorInfo));
      }
    });
  };
  const getShopToken = (token) => {
    doRelativeLogin({ token, source: 'MATERIAL', platform: 'MATERIAL_MALL_H5' }).then(res => {
      if (res.token) {
        shopPlatFun(res.token);
      }
    })
  }
  const queryQrCodeStatusFn = (qrCodeKey) => {
    clearInterval(interval);
      set_interval(
      setInterval(() => {
        queryQrCodeStatus({ qrCodeKey: qrCodeKey }).then(async (res) => {
          if (res.success && res.token) {
            if (isShop) {
              getShopToken(res.token);
              return;
            }
            setLoginName("");
            const days = platform === 'MATERIAL_H5' ? 90 : 7
            setCookie('mtoken', res.token, days)
            setCookie('platform', platform, days)
            clearInterval(interval);
            // H5 微信扫码登录后先校验手机号/邮箱，未绑定则先去绑定页补齐账号信息。
            try {
              const rawUser = await queryUserByToken(res.token);
              const user =
                typeof rawUser === "string" ? JSON.parse(rawUser) : rawUser;
              if (user && typeof user === "object") {
                window.__user__ = user;
                localStorage.setItem("user", JSON.stringify(user));
              }
              if (!hasBoundLoginContact(user)) {
                // 私域邀请扫码登录前已经保存了回跳上下文，不能用当前登录页地址覆盖它。
                if (!getLoginModalWechatReturnContext()?.returnUrl) {
                  saveLoginModalWechatReturnUrl();
                }
                window.location.replace("/bindPhone.html");
                return;
              }
            } catch {
              // 用户信息查询失败时继续执行后续登录回调，由业务页处理登录状态。
            }
            // location.reload();
            loginSucCallback(res);
            // // 从委托产品页跳转过来的
            // if(loginSucFun){
            //   loginSucFun();
            //   return
            // }
            // if(sessionStorage.getItem('isFirst')==='1') {
            //   setIslogin(true);
            //   return;
            // }
            // if(res.result?.lastUrl) {
            //   const lastUrl= getLastOrigin(res.result?.lastUrl);
            //   window.location.href = lastUrl;
            //   localStorage.setItem('lastUrl',lastUrl);
            // }else{
            //   localStorage.setItem('lastUrl','');
            //   // location.reload();
            //   getUrl();
            // }
          }
        });
      }, 3000)
    );
  };
  useEffect(() => {
    setTimeout(() => {
      if (loginName === "盘子登录") {
        clearInterval(interval);
        queryQrCodeFn();
      }
    }, 100);
    const timer = setInterval(() => {
      if (loginName === "微信登录") {
        queryCodeFn();
      }
      if (loginName === "盘子登录") {
        queryQrCodeFn();
      }
      if (!loginName || loginName === "支付宝登录") {
        clearInterval(timer);
      }
    }, 60000);
    return () => {
      clearInterval(timer);
    };
  }, [loginName]);

  const wxauthLogin = () => {
    let url = window.location.origin;
    const host = window.location.host;
    let appid = 'wx80dfb3bc1c99533b';
    if (url.indexOf(":3001") >= 0 || url.indexOf("ngtest.guyubao.com") >= 0) {
      url = `https://${ym_url.test}`;
      // url = "http://ajf5drq9ve9w.ngrok.xiaomiqiu123.top"
    }
    if (host.indexOf('material-pre') >= 0) {
      appid = 'wx26852148b145376b';
    } else if (origin.indexOf('material-test') < 0) {
      appid = 'wx54e4bc4ffda6e5f1';
    }
    let srt = '';
    const { key, val,  url: openUrl } = getUrlByHadParam(1,true);
    if (openUrl) {
      srt =  openUrl;
      localStorage.setItem(key, val);
      if (key === 'clientId') localStorage.setItem('entrust', val);
    }
    // if(unicode_url) {
    //   srt = `?type=2&key=${unicode_url}`
    //   localStorage.setItem('unicode',unicode_url);
    // }else if(entrust) {
    //   if(entrust === clientId){
    //     srt = `?type=3&key=${entrust}`
    //     localStorage.setItem('clientId',clientId);
    //   }else{
    //     srt = `?type=4&key=${entrust}`
    //     localStorage.setItem('entrust',entrust);
    //   }
    // sdf委托您添加团队库数据，点击链接开始操作：
    // }else if(inviteCode) {
    //   srt = `?type=5&key=${inviteCode}`
    //   localStorage.setItem('inviteCode',inviteCode);
    // }else if(share_product) {
    //   srt = `?type=1&key=${share_product}`
    //   localStorage.setItem('share_product',share_product);
    // }else if(share_main){
    //   localStorage.setItem('share_main',share_main);
    //   srt = `?type=6&key=${share_main}`;
    // }
    // type=1:`/product_detail_share.html?id=${key}`
    // type=2:`/team_join_link.html?unicode=${key}`
    // type=3 :`/create_product.html?clientType=3&clientId=${key}&operation=CREATE&entrust=${key}`
    // type=4 :`/entrust_product.html?key=${key}`
    // type=5:`/invite_settle.html?inviteCode=${key}`
    // type=6:`/share_page.html?key=${key}&isProduct=1`
    // type=7:`/material_square.html`
    // type=8:`/team_home.html?clientId=${entrust}&clientType=2&selectTab=3`
    // type=9:`/product_detail.html?type=${collectType}&id=${collectId}&clientId=${entrust}&clientType=2&hadShare=0&backHome=1`
    // type=10:`/team.html/#/teamBrand?clientId=${entrust}&brandId=${brandId}`

    if (srt) {
      queryWxCallbackUrl({ redirectUrl: srt }).then((res) => {        
        if (res.success) {
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
            buildWxWebLoginUrl(url, res.result)
          )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
        }
      })
      return
    }
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
      buildWxWebLoginUrl(url, srt)
    )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;

    // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
    //   `${url}/api/wx/webLogin${srt}&platform=${platform}`
    // )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
  }
  const backToLogin = () => {
    setLoginName("");
    setOtherLoginVisible(false);
    clearInterval(interval);
    setPwdLogin(false);
    setVisible(true);
  };

  // 微信扫码卡片跟随「呈现」判定：PC 与 pad（平板跟随 PC 呈现）共用同一张卡片，
  // 手机端仍是原来那套（手机端不渲染这张卡片）。
  const isWechatLogin = !isPhone && loginName === "微信登录";

  return (
    <div className={`boxMask${isWechatLogin ? " wechat-login-mask" : ""}`}>
      <div className={`boxContent${isWechatLogin ? " wechat-login-content" : ""}`}>
        {isWechatLogin ? (
          <>
            <div className="wechat-login-brand">
              <img src={brightlogo} alt="" />
            </div>
            <div className="wechat-login-main">
              <h2>{t("微信登录")}</h2>
              <div className="otherCode wechat-login-code">
                <iframe
                  id="iframe"
                  title={t("微信登录二维码")}
                  width={300}
                  height={392}
                  frameBorder={0}
                  scrolling={"no"}
                  src={direct+"&fast_login=0"}
                  sandbox="allow-scripts allow-same-origin allow-top-navigation"
                ></iframe>
              </div>
            </div>
            <div className="wechat-login-actions">
              <p>{t("使用微信扫一扫登录“不觉”")}</p>
              <button type="button" onClick={backToLogin}>
                {t("返回其他登录方式")}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="text_title bjweb-flex-space">
              <span>{loginName ? t(loginName) : ""}</span>
              <span
                className="validateText cursor"
                style={{ fontWeight: 'normal', fontSize: 12 }}
                onClick={backToLogin}
              >
                {t("返回")}
              </span>
            </div>
            <div className="otherCode">
              <iframe
                id="iframe"
                width={300}
                height={320}
                frameBorder={0}
                scrolling={"no"}
                src={direct+"&fast_login=0"}
                sandbox="allow-scripts allow-same-origin allow-top-navigation"
                style={{
                  position: "relative",
                  top: "0",
                }}
              ></iframe>
            </div>
            <div className="otherLogin bjweb-flex-center">
              <span></span>
              <div>{t("其他登录方式")}</div>
              <span></span>
            </div>
            <div className="other_img">
              {/* <img
                onClick={(e) => {
                  e.stopPropagation();
                  setLoginName("盘子登录");
                }}
                referrerPolicy="no-referrer"
                src={pzLogo}
              /> */}
              <img
                onClick={(e) => {
                  e.stopPropagation();
                  clearInterval(interval);
                  if (isWx) {
                    wxauthLogin();
                  } else {
                    queryCodeFn();
                  }

                }}
                referrerPolicy="no-referrer"
                src={wxLogo}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
